import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function CityDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("City")}
      endpoint={`/cities/${props.match.params.id}/`}
      successRoute={reverse("cityList")}
      errorRoute={reverse("cityDetail", { id: props.match.params.id })}
    />
  )
}

CityDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
